import { logError } from '@/utils/logHandling';

export type SetExerciseClass = 'word' | 'sentence' | 'text';

const EXERCISE_CLASS_FROM_SET_TYPE: Record<string, SetExerciseClass> = {
  Wörtersets: 'word',
  Sätzesets: 'sentence',
  Textesets: 'text',
  wordset: 'word',
  sentenceset: 'sentence',
  textset: 'text',
  word: 'word',
  sentence: 'sentence',
  text: 'text',
};

export const setStorageKey = (
  setId: string,
  exerciseClass: SetExerciseClass | string,
): string => {
  const cls = EXERCISE_CLASS_FROM_SET_TYPE[exerciseClass];
  if (!cls) {
    logError(
      `setStorageKey: unknown exerciseClass "${exerciseClass}" for setId "${setId}", defaulting to "word"`,
    );
    return `word${setId}`;
  }
  return `${cls}${setId}`;
};

// Detects if a key is a new-style prefixed set key and extracts the bare ID
// MongoDB ObjectIDs are 24 hex chars
const MONGODB_ID_REGEX = /^[0-9a-f]{24}$/i;
const SET_KEY_PREFIXES = ['word', 'sentence', 'text'] as const;

export const extractSetIdFromPrefixedKey = (key: string): string | null => {
  for (const prefix of SET_KEY_PREFIXES) {
    if (key.startsWith(prefix)) {
      const possibleId = key.slice(prefix.length);
      if (MONGODB_ID_REGEX.test(possibleId)) {
        return possibleId;
      }
    }
  }
  return null;
};

export const isSetStorageKey = (key: string): boolean =>
  extractSetIdFromPrefixedKey(key) !== null;
